import {FC} from 'react';
import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';

export const PowerPointIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='PowerPoint File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zM4.035 9.29h4.83c.67 0 1.24.097 1.71.293a3.2 3.2 0 0 1 1.148.772c.295.32.51.685.644 1.095a4.073 4.073 0 0 1 0 2.543c-.135.415-.35.782-.645 1.102a3.2 3.2 0 0 1-1.147.772c-.47.196-1.04.293-1.71.293H6.39V20H4.035V9.29zm2.355 5.04h1.83c.27 0 .53-.02.78-.06.25-.04.47-.117.66-.232.19-.116.342-.278.457-.488.116-.21.173-.485.173-.825 0-.34-.057-.615-.172-.825a1.267 1.267 0 0 0-.458-.488A1.815 1.815 0 0 0 9 11.18c-.25-.04-.51-.06-.78-.06H6.39v3.21z'
            fillRule='nonzero'
        />
    </SvgIcon>
);
